<div class="icon-cont ">
  <a class="social-icon" target="_blank" rel="noopener" href="{{componentData.url}}" role="button">
      <i class="fab fa-linkedin-in"></i>
  </a>
</div>